/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import WISHLIST from './wishlistOptions';
import WATCH from './watchOptions';
import RECORDINGS from './recordingsOptions';
import FOLDERS from './foldersOptions';
// import HOWPURCHASE from './howToPurchaseOptions';
import PURCHASES from './purchasesOptions';
import FOLDER_PURCHASES from './folderPurchasesOptions';
import TRAILER from './trailerOptions';

export default {
  getWishlistOptions: WISHLIST.getOptions,
  getWatchOptions: WATCH.getOptions,
  getRecordingsOptions: RECORDINGS.getOptions,
  getFoldersOptions: FOLDERS.getOptions,
  // getHowToPurchaseOptions: HOWPURCHASE.getOptions,
  getPurchasesOptions: PURCHASES.getOptions,
  getFolderPurchasesOptions: FOLDER_PURCHASES.getOptions,
  getTrailerOptions: TRAILER.getOptions,
};
